import React, { Component } from "react";
import { Grid, Box, CardContent, CardMedia } from "@mui/material";
import CtTxt from "./CustomTool/CtTxt";
import CtDtp from "./CustomTool/CtDtp";
import CtTxtAmt from "./CustomTool/CtTxtAmt";
import CtTxtNum from "./CustomTool/CtTxtNum";
import CtCmb from "./CustomTool/CtCmb";
import TextAreaAutoSize from "./CustomTool/TextAreaAutoSize";
import CtBtn from "./CustomTool/CtBtn";
import { Edit, Delete, ThirtyFpsSharp } from "@mui/icons-material";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import { withRouter } from "../HOC/withRouter";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import { connect } from "react-redux";
import Progress from "./CustomTool/Progress";
import {
  mapStatetoProps,
  mapSetActiveMenuToProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";
import { fetchItemDetail, fetchItemMaster, fetchLoadUnload } from "./API";
import {
  get_YMD_from_SYS,
  get_30DaysBack_FromCurrentDate,
  isValidItem,
  getlocalstoragedate,
  setlocalstoragedate,
  applyTrimOnObjectValues,
  csvFileName,
} from "../SystemUtility/SystemUtility";
import TableList from "./CustomTool/TableList";
import VehicleUnload from "./VehicleUnload";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import ResetDate from "../images/resetdate.png";
import MaterialTable from "./CustomTool/MaterialTable";
import CustomerMaster from "./CustomerMaster";
import LedgerMaster from "./LedgerMaster";
import TripItemEntry from "./TripItemEntry";
import CtART from "./CustomTool/ResponsiveTable";

class ItemMaster extends Component {
  state = {
    formData: {
      edit_int_jansicode: 0,
      ItemCode: 0,
      jansiname: "",
      Commission: "",
      MarketFee: "",
    },

    columns: [
      {
        accessorKey: "int_jansicode",
        header: "જણસી કોડ",
      },
      {
        accessorKey: "vac_jansiname",
        header: " જણસી નામ",
      },

      {
        accessorKey: "dec_commision",
        header: "કમિશન (%)",
      },
      {
        accessorKey: "dec_marketfees",
        header: "માર્કેટ ફી",
      },
    ],
    rows: [],

    rowsCount: 0,
    rowsPerPage: 50,
    counter: 0,

    dataLoadStatus: true,
    ARD: null,
  };

  //#region Component
  componentDidMount() {
    {
      !this.props.showHeading && (document.title = "RA : જણસી માસ્ટર");
    }
    this.props.setActiveMenu("ItemMaster");
    this.props.verifyUserID(
      this.onFormLoad,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
  }
  //#endregion Component

  //#region Handle

  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };
  handleChangeRowsPerPageOtherDetail = (rowsPerPageOtherDetail) => {
    this.setState({ rowsPerPageOtherDetail });
  };
  //  handleARDonActionClick_Edit = () => {};

  //   handleARDonActionClick_Delete = () => {};

  handleOnNewEntryClick = () => {
    let ARD = null;
    this.setState({ ARD }, () => {
      ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          // New : Sales Item Entry'
          alertMessage={<TripItemEntry />}
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );
      this.setState({ ARD });
    });
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };

  handleOnRowDataChange = (rows, handledRowIndex, colID) => {
    this.setState({ rows, rowsCount: rows.length }, () => {});
  };

  //#endregion handle

  trimFormData = (nextFunctionCall) => {
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
      excludeKeysArray: ["chkReceiptGenerated"],
    });
    this.setState({ formData }, () => {
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  onFormLoad = () => {
    let dataLoadStatus = false;
    this.setState({ dataLoadStatus }, () => {
      const reqData = {
        Op: "LoadItem",
        bint_acid: localStorage.getItem("acid"),
        int_jansicode: this.state.formData.ItemCode,
      };
      fetchItemDetail(reqData)
        .then((res) => {
          dataLoadStatus = true;
          let ItemCode =
              Number(this.state.formData.ItemCode) > 0
                ? this.state.formData.ItemCode
                : res.data.nextJansicode,
            rows = [],
            rowsCount = 0;
          if (res.data.ItemList && res.data.ItemList.length > 0) {
            rows = res.data.ItemList;
            rowsCount = rows.length;
          }
          this.setState(
            {
              dataLoadStatus,
              rows,
              rowsCount,
              formData: {
                ...this.state.formData,
                ItemCode,
              },
            },

            () => {
              document.getElementById("jansiname").focus();
            }
          );
        })
        .catch((error) => {
          console.log("Unknown error occurred in onFormLoad.", error);
        });
    });
  };
  handleARDonActionClick_Delete = (row) => {
    const int_jansicode = row.getValue("int_jansicode"),
      jansiname = row.getValue("vac_jansiname");
    this.DeleteData(int_jansicode, jansiname);
  };

  DeleteData = (int_jansicode, jansiname) => {
    const itemExists = this.state.rows.some(
      (row) => row.int_jansicode === int_jansicode
    );
    if (int_jansicode > 0 && itemExists) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={
              "Do you want to Item Name : " +
              (jansiname !== undefined
                ? jansiname
                : this.state.formData.jansiname) +
              " ?"
            }
            alertMessage=""
            handleOnClickYes={() => {
              return this.DeleteItemList(int_jansicode);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );

        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("Select a record for deletion.");
    }
  };

  DeleteItemList = (int_jansicode) => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "DeleteItem",
      bint_acid: localStorage.getItem("acid"),
      int_jansicode: int_jansicode,
      bol_list: true,
    };
    fetchItemDetail(reqData)
      .then((res) => {
        this.props.updateProcessing(res.data.msgType, res.data.message);
        if (res.data.msgType === "success") {
          let rows = [],
            rowsCount = rows.length;
          if (res.data.ItemList && res.data.ItemList.length > 0) {
            rows = res.data.ItemList;
            rowsCount = rows.length;
          }
          this.setState(
            {
              rows,
              rowsCount,
              ARD: null,
            },
            () => {
              this.clearInfo();
            }
          );
        }
      })
      .catch((error) => {
        this.props.updateProcessing(
          "error",
          "Unknown error occurred in delete Check list. " + error
        );
      });
    return false;
  };

  handleARDonActionClick_Edit = (row) => {
    console.log("row", row);
    const edit_int_jansicode = row.getValue("int_jansicode"),
      ItemCode = row.getValue("int_jansicode"),
      jansiname = row.getValue("vac_jansiname"),
      Commission = row.getValue("dec_commision"),
      MarketFee = row.getValue("dec_marketfees");

    // console.log("rows2", rows2);
    this.setState({
      formData: {
        ...this.state.formData,
        edit_int_jansicode,
        ItemCode,
        jansiname,
        Commission,
        MarketFee,
      },
    });
    window.scrollTo(0, 0);
    document.getElementById("jansiname").focus();
  };
  clearInfo = () => {
    let edit_int_jansicode = 0,
      jansiname = "",
      Commission = "",
      MarketFee = "";
    this.props.notifyProcessing();
    const reqData = {
      Op: "LoadItem",
      bint_acid: localStorage.getItem("acid"),
      int_jansicode: 0,
    };
    fetchItemDetail(reqData)
      .then((res) => {
        this.props.closeUpdateProcessing();
        this.setState({
          formData: {
            ...this.state.formData,
            ItemCode: res.data.nextJansicode,
            edit_int_jansicode,
            jansiname,
            Commission,
            MarketFee,
          },
        });
      })
      .catch((error) => {
        console.log("Unknown error occurred in onFormLoad.", error);
      });
    document.getElementById("jansiname").focus();
  };
  validatItemMaster = () => {
    let result = false;
    if (this.state.formData.ItemCode.length <= 0) {
      this.props.toastErrorMsg("જણસી કોડ ઉમેરો", "ItemCode");
    } else if (this.state.formData.jansiname.length <= 0) {
      this.props.toastErrorMsg("જણસી નામ ઉમેરો", "jansiname");
    } else {
      result = true;
    }
    return result;
  };
  SaveItem = () => {
    if (this.validatItemMaster()) {
      let dataLoadStatus = false;
      this.props.notifyProcessing();
      this.setState({ dataLoadStatus }, () => {
        const reqData = {
          Op: "SaveItem",
          bint_acid: localStorage.getItem("acid"),
          edit_int_jansicode: this.state.formData.edit_int_jansicode,
          int_jansicode: this.state.formData.ItemCode,
          vac_jansiname: this.state.formData.jansiname,
          dec_commision: this.state.formData.Commission,
          dec_marketfees: this.state.formData.MarketFee,
        };
        fetchItemDetail(reqData)
          .then((res) => {
            this.props.updateProcessing(res.data.msgType, res.data.message);
            dataLoadStatus = true;
            if (res.data.msgType === "success") {
              if (res.data.ItemList && res.data.ItemList.length > 0) {
                let ItemCode = res.data.nextJansicode,
                  rows = res.data.ItemList,
                  rowsCount = rows.length;
                this.setState(
                  {
                    dataLoadStatus,
                    rows,
                    rowsCount,
                    formData: {
                      ...this.state.formData,
                      ItemCode,
                    },
                  },
                  () => {
                    this.clearInfo();
                  }
                );
              }
            } else {
              this.setState({
                dataLoadStatus,
              });
            }
          })
          .catch((error) => {
            console.log(
              "Unknown error occurred in SaveReferenceMaster.",
              error
            );
          });
      });
    }
  };
  render() {
    return (
      <form>
        <Progress
          color="primary"
          display={this.state.dataLoadStatus !== true}
        />
        {this.props.showHeading && (
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            className="title"
          >
            <label
              htmlFor="Title"
              style={{ fontSize: "25px", color: "#6f7689" }}
            >
              <b>જણસી માસ્ટર</b>
            </label>
          </Grid>
        )}
        <Grid
          container
          direction="column"
          spacing={2}
          justifyContent="center"
          alignItems="center"
        >
          <Grid item>
            <Grid
              container
              direction="row"
              spacing={2}
              marginTop={0}
              justifyContent="flex-start"
              alignItems="center"
            >
              <Grid item>
                <CtTxtNum
                  id="ItemCode"
                  value={this.state.formData.ItemCode}
                  handleOnChange={this.handleOnChange}
                  label="જણસી કોડ*"
                  width={250}
                  maxLength={100}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="jansiname"
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="jansiname"
                  value={this.state.formData.jansiname}
                  handleOnChange={this.handleOnChange}
                  label="જણસી નામ*"
                  width={250}
                  maxLength={100}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID="Commission"
                />
              </Grid>
            </Grid>

            <Grid
              container
              direction="row"
              spacing={2}
              marginTop={0}
              justifyContent="flex-start"
              alignItems="center"
            >
              <Grid item>
                <CtTxtAmt
                  id="Commission"
                  value={this.state.formData.Commission}
                  handleOnChange={this.handleOnChange}
                  label="કમિશન (%)"
                  width={250}
                  maxLength={10}
                  onKeyDown={this.props.onKeyDown}
                  defaultAction={this.SaveItem}
                  nextCtrlID="MarketFee"
                />
              </Grid>
              <Grid item>
                <CtTxtAmt
                  id="MarketFee"
                  value={this.state.formData.MarketFee}
                  handleOnChange={this.handleOnChange}
                  label="માર્કેટ ફી"
                  width={250}
                  maxLength={10}
                  onKeyDown={this.props.onKeyDown}
                  defaultAction={this.SaveItem}
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              spacing={2}
              marginTop={1}
              justifyContent="flex-start"
              alignItems="center"
            >
              <Grid item>
                <CtBtn label="Save" onClick={this.SaveItem} />
              </Grid>

              <Grid item>
                <CtBtn
                  label="New"
                  onClick={this.clearInfo}
                  variant={"outlined"}
                />
              </Grid>
              <Grid item>
                <CtBtn
                  disabled={
                    Number(this.state.formData.edit_int_jansicode) > 0
                      ? false
                      : true
                  }
                  label="Delete"
                  onClick={() => this.DeleteData(this.state.formData.ItemCode)}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <br />

        <Grid item marginTop={3} className="maintable">
          {/* <MaterialTable
            rowsdata={this.state.rows}
            columnsdata={this.state.columns}
            rowsPerPage={this.state.rowsPerPage}
            tblmaxHeight={500}
            onEditAction={this.handleARDonActionClick_Edit}
            onDeleteAction={this.handleARDonActionClick_Delete}
            showColumnFilters={false}
            actionColSize={30}
            density={"compact"}
            handleOnNewEntryClick={this.handleOnNewEntryClick}
          /> */}
          <CtART
            rowsdata={this.state.rows}
            columnsdata={this.state.columns}
            rowsPerPage={this.state.rowsPerPage}
            tblmaxHeight={500}
            csvFileName={csvFileName("ItemMaster")}
            rowIconAction={[
              {
                label: "Edit",
                onClick: this.handleARDonActionClick_Edit,
                icon: "Edit",
                className: "secondary-button",
              },
              {
                label: "Delete",
                onClick: this.handleARDonActionClick_Delete,
                icon: "delete",
                className: "delete-button",
              },
            ]}
            showColumnFilters={false}
            actionColSize={30}
            hideColIdList={[""]}
            density={"compact"}
          />
        </Grid>
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(ItemMaster))));
